import tw from 'twin.macro';

export const TrendingBadge = ({ value }: { value: number }) => {
  if (!value)
    return (
      <div tw='flex justify-center items-center bg-muted text-[12px] text-muted2 font-medium rounded-[6px] p-[4px]'>
        {0}%
      </div>
    );

  return (
    <div
      tw='flex justify-center items-center bg-success-icon-bg text-[12px] text-success-text-and-icon font-medium rounded-[6px] p-[4px]'
      css={[value < 0 && tw`text-error-text-icon bg-error-icon-bg`]}>
      {value > 0 ? '+' + value.toFixed(2) : value.toFixed(2)}%
    </div>
  );
};
